import api from '../axios';

export const GET_ALL_TICKETS = 'GET_ALL_TICKETS'

export const getAllTickets = () => (dispatch) => {
    let options = {
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
    };
    return api.get('/tickets' + '?size=300', options)
        .then((response) => {
            dispatch({ type: GET_ALL_TICKETS, payload: response.data})
            return Promise.resolve(response.data)
        })
        .catch((error) => {
            return Promise.reject(error.response.data.error)
        })
}
